import { InjectionToken } from '@angular/core'
import { PATH_ICON } from '../configs/dashboard-config'

export const SVG_ICON_SRC = new InjectionToken('svg-icon-src', {
    factory: (): string => PATH_ICON
})
